import * as React from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import request from "../../../utilities/requests";

const NotesDialog = ({ open, close, otherUser, eventId }) => {
  const [notes, setNotes] = React.useState("");

  React.useEffect(() => {
    if (open && otherUser) {
      getNotes();
    }
  }, [open, otherUser]);

  const getNotes = async () => {
    const result = await request(
      `pairing/mixernotes?eventId=${eventId}&otherUser=${otherUser}`
    );
    if (result.success) {
      setNotes(result?.notes?.text || "");
    }
  };

  const saveNotes = async () => {
    if (notes === "") {
      close();
      return;
    }
    const body = {
      eventId,
      otherUser,
      notes,
    };
    const result = await request("pairing/mixernotes", "post", body);
    if (!result?.success) {
      alert(result.error);
    }
    close();
  };

  return (
    <Dialog open={open} onClose={() => close()} fullWidth>
      <DialogTitle id="alert-dialog-title">{"Notes"}</DialogTitle>
      <DialogContent>
        <TextField
          label="notes"
          multiline
          rows={10}
          fullWidth
          style={{ marginTop: 10 }}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()} autoFocus>
          Cancel
        </Button>
        <Button onClick={() => saveNotes()} autoFocus>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotesDialog;
